import { fromJS } from "immutable"
import { createSelector, createStructuredSelector } from "reselect"
import { selectSearchFlvSlice } from "shared/search/selectors"
import { selectAllCustomFields } from "shared/customFields/selectors"
import { setDefaultValue, createCustomFieldNameDict, createParsedCustomFieldsArray } from "shared/customFields/constants/helperFunctions"
import { selectStancesWithCustomLabels } from "shared/stance/selectors"
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"

export const selectInlineId = (state, props) => props.inlineId

export const selectInlineAppearance = createSelector(
    [
        selectSearchFlvSlice,
        selectInlineId,
        (state, props) => props.datum
    ],
    (searchFlvSlice, inlineId, datum) => {
        const returnVal = searchFlvSlice.getIn(["inlineAppearanceValues", datum.get("id")])
        return returnVal || fromJS({})
    }
)

export const selectInlineCustomTags = createSelector(
    [
        (state, props) => (props && props.quorumDataType),
        (state, props) => (props && props.datum && props.datum.get && props.datum.get("tag_dict")),
        selectAllCustomFields,
    ],
    (qdt, tagDict, customTags) => {
        if (!tagDict || !tagDict.size || !customTags.length) {
            return []
        }

        const { custom_event, custom_event_participant, public_organization } = DjangIO.app.models.QuorumDataType

        // Format tags with default values
        const formattedCustomTags = () => {
            if (qdt.value === public_organization.value) {
                return []
            } else if (qdt && customTags) {
                return customTags
                .filter(
                    object => (
                        // For CustomEventParticipant inlines, show CustomEvent custom fields with CustomEventParticipant tag_dict values
                        object.tag_owner === custom_event.value &&
                        qdt.value === custom_event_participant.value
                    ) || object.tag_owner === qdt.value // For all other inlines, have same CustomField tag_owner and object datatype
                ).map(object => setDefaultValue(object))
            }

            return []
        }

        // Parse custom tags to readable values
        return createParsedCustomFieldsArray(
            createCustomFieldNameDict(formattedCustomTags()),
            tagDict && tagDict.toJS ? tagDict.toJS() : tagDict
        )
    }
)

export const inlineConnection = createStructuredSelector({
    appearanceValues: selectInlineAppearance,
    customFields: selectInlineCustomTags,
    stanceOptions: selectStancesWithCustomLabels,
})
